/**
 * API生成器
 *
 * 整合service/api中的接口文件，最终以对象的方式暴露出去，以便访问。
 *
 * 整合之后的对象：
 * {
 *   api: {
 *       '{文件名}/{api的name字段}'(outerParams, outerOptions = {}) {
 *           // 处理接口参数与默认配置参数
 *           return axios(options);
 *       }
 *   }
 * }
 *
 * 比如:
 * {
 *   api: {
 *       'cash/getUserAuthStatus'(outerParams, outerOptions = {}) {
 *           // 处理接口参数与默认配置参数
 *           return axios(options);
 *       },
 *      'cash/publish'(outerParams, outerOptions = {}) {
 *           // 处理接口参数与默认配置参数
 *           return axios(options);
 *       }
 *      ...
 *   }
 * }
 *
 * 用法：
 *      this.$api["cash/getUserAuthStatus"](params, otherparams).then(res => {
 *          // success
 *      }).catch(erroe => {
 *          // fail
 *      })
 */

import axios from './axios';
// import _pick from 'lodash/pick';
import _assign from 'lodash/assign';
import _isEmpty from 'lodash/isEmpty';

import { assert } from '@/utils/tools';
import { API_DEFAULT_CONFIG, AXIOS_OPTIONS_CONFIG } from '@/config';
import API_CONFIG from '@/service/api';

class MakeApi {
	constructor(options) {
		this.api = {};
		this.apiBuilder(options);
	}

	apiBuilder({ sep = '|', config = {}, debug = false }) {
		Object.keys(config).map(namespace => {
			this._apiSingleBuilder({
				namespace,
				sep,
				debug,
				config: config[namespace]
			});
			return namespace;
		});
	}
	_apiSingleBuilder({ namespace, sep = '|', config = {}, debug = false }) {
		config.forEach(api => {
			const { name, desc, params = {}, method, path, options = {} } = api;
			// let apiname = `${namespace}${sep}${name}`;
			let url = path;
			let apiUrl = path; // temp

			debug && assert(name, `${apiUrl} :接口name属性不能为空`);
			debug &&
				assert(
					apiUrl.indexOf('/') === 0,
					`${apiUrl} :接口路径path，首字符应为/`
				);

			Object.defineProperty(this.api, `${namespace}${sep}${name}`, {
				value(outerParams, outerOptions = {}) {
					// let _data = _isEmpty(outerParams)
					//     ? params
					//     : _pick(_assign({}, params, outerParams), Object.keys(params));

					const _options = _isEmpty(outerParams)
						? options
						: _assign(
								{ ...AXIOS_OPTIONS_CONFIG },
								options,
								outerOptions
						  );

					let _data;
					if (_options.contenttype === 'formdata') {
						_data = outerParams;
					} else {
						_data = _isEmpty(outerParams)
							? params
							: _assign({}, params, outerParams);
					}

					return axios(
						_normoalize(
							_assign(
								{
									url,
									desc,
									method
								},
								_options
							),
							_data
						)
					);
				}
			});
		});
	}
}

function _normoalize(options, data) {
	if (options.method === 'POST') {
		options.data = data;
	} else if (options.method === 'GET') {
		options.params = data;
	}
	return options;
}

export default new MakeApi({
	config: API_CONFIG,
	...API_DEFAULT_CONFIG
})['api'];
